import { useSelector } from 'react-redux';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import type { RootState } from 'reactApp/store';
import type { Tariff } from 'reactApp/types/Billing';

export const useTariffs = ({ isPro, isOneTariff }: { isPro: boolean; isOneTariff: boolean }): Tariff[] => {
    const userSpace = useSelector(UserQuotaSelectors.getTotal);

    // tempexp_16790-start
    const defaultTariffs = useSelector(ProductsSelectors.overquotaPopupDefaultTariffs);
    const proTariff = useSelector((state: RootState) => ProductsSelectors.overquotaPopupProTariff(state, userSpace?.original || 0, false));
    const discountTariff = useSelector((state: RootState) =>
        ProductsSelectors.overquotaPopupProTariff(state, userSpace?.original || 0, true)
    );
    // tempexp_16790-end

    if (isPro && proTariff) {
        return [proTariff];
    }

    if (isOneTariff && discountTariff) {
        return [discountTariff];
    }

    return defaultTariffs.slice(0, 3);
};
